// @ts-nocheck
import { handleError } from '../utilities';
import store from '../store';

export async function loadPlugins() {
  try {
    const {
      baseUrl,
      disableLoadPlugins,
      format,
      projectId,
      regionTemplate: {
        settings: {
          consent: { blockingMode = 'disabled' } = {},
          privacyCenter: { privacyRequests = true } = {},
        } = {},
      } = {},
    } = store.config;

    if (
      (blockingMode !== 'disabled' || privacyRequests) &&
      !disableLoadPlugins
    ) {
      const widget = document.createElement('script');
      widget.src =
        format === 'iife'
          ? `${baseUrl}/site-v1/${projectId}/widget?format=iife`
          : `${baseUrl}/site-v1/${projectId}/widget`;
      widget.type = 'text/javascript';
      widget.async = true;
      const s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(widget, s);
    }
  } catch (err) {
    handleError(err);
  }
  return null;
}
